module.exports = __webpack_public_path__ + "static/media/nike.7c6f96e1.svg";